<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="inbox"></font-awesome-icon>
          {{ $t('chatHistory') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <client-select class="mr-1 mb-2" :model="filterFormModel"
                           attribute="client" :isFilter="true" :place-holder="$t('selectClient')"></client-select>
            <form-select :model="filterFormModel" attribute="fromContact" class="mr-1 mb-2"
                         :options="[
                             {value: null, text: $t('selectContact') },
                             {value: true, text: $t('sendFromCustomer') },
                             {value: false, text: $t('sendFromCallio') },
                         ]"></form-select>
            <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-2"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-2">Reset</button>
            <chat-export
                v-if="['owner', 'admin', 'tech', 'operationsManager', 'account'].includes($store.state.user.role)"
                :filter="filterFormModel" :total-count="itemCount"></chat-export>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount > 0">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length > 0">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('client') }}</div>
            <div class="col-lg-1">{{ $t('type') }}</div>
            <div class="col-lg-1">{{ $t('customer') }}</div>
            <div class="col-lg-3">{{ $t('content') }}</div>
            <div class="col-lg-2">{{ $t('createTime') }}</div>
            <div class="col-lg-2">{{ $t('supportUser') }}</div>
            <div class="col-lg-1">{{ $t('socialNetworkAccount') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <span><b>{{ $t('name') }}: </b> {{ item.client.companyName }}</span>
              <span><b>Domain: </b>{{ item.client.domain }}</span>
            </div>
            <div class="col-lg-1">
              <div>
                <p>{{ $t(item.type) }}</p>
                <span class="badge badge-primary" v-if="item.fromContact">{{ $t('sendFromCustomer') }}</span>
                <span class="badge badge-info" v-if="!item.fromContact">{{ $t('sendFromCallio') }}</span>
              </div>
            </div>
            <div class="col-lg-1">
              <p>{{ item.customer.name }}</p>
            </div>
            <div class="col-lg-3">
              <p v-if="item.content">{{ item.content }}</p>
              <p v-else-if="item.attachments && item.attachments.length">
                <a :href="item.attachments[0].url" target="_blank" rel="noopener noreferrer">{{ $t('url') }}</a>
              </p>
            </div>
            <div class="col-lg-2">
              <p>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</p>
            </div>
            <div class="col-lg-2">
              <p v-if="item.user">{{ item.user.name }} ({{ item.user.ext }})</p>
            </div>
            <div class="col-lg-1">
              <p v-if="item.socialNetworkAccount">{{ item.socialNetworkAccount.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="items.length === 0 && !loading">
        {{ $t('notFound') }}
      </div>
      <div class="col-12" v-if="itemCount > 0">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                        v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                        @input="load">
          </b-pagination>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import List from "@/mixins/List";
import TimeRangePicker from "@/components/TimeRangePicker.vue";
import ClientSelect from "@/components/ClientSelect.vue";
import ChatExport from "@/views/message/export/ChatExport.vue";

export default {
  components: {ChatExport, ClientSelect, TimeRangePicker},
  mixins: [List],
  data: function () {
    return {
      service: '/customer-log',
      autoLoad: true,
      defaultFilterFormModel: {
        client: this.clientId || null,
        fromContact: null,
      }
    }
  },
  i18n: {
    messages: {
      en: {
        chatHistory: "Chat history",
        selectClient: "Select client",
        selectContact: "Select contact",
        sendFromCustomer: "Send from customer",
        sendFromCallio: "Send from callio",
        search: "Search",
        type: "Type",
        customer: "Customer",
        content: "Content",
        createTime: "Create time",
        supportUser: "Support user",
        socialNetworkAccount: "Social network account",
        notFound: "Not found any record",
        chat: "Chat",
        url: "URL",
      },
      vi: {
        chatHistory: "Lịch sử chat",
        selectClient: "Chọn khách hàng",
        selectContact: "Chọn liên hệ",
        sendFromCustomer: "Gửi từ khách hàng",
        sendFromCallio: "Gửi từ Callio",
        search: "Tìm kiếm",
        type: "Loại",
        customer: "Khách hàng",
        content: "Nội dung",
        createTime: "Tạo lúc",
        supportUser: "Người hỗ trợ",
        socialNetworkAccount: "Tài khoản xã hội",
        notFound: "Không tìm thấy bản ghi nào",
        url: "URL chi tiết",
      }
    }
  }
}
</script>